import axiosClient from "./axiosClient";

export async function getMySubscriptions() {
  const response = await axiosClient.get("/subscriptions/mine");
  return response.data;
}

export async function getMySubscriptionDetail(storeId) {
  const response = await axiosClient.get(`/subscriptions/mine/${storeId}`);
  return response.data;
}
